import { Capacitor } from '@capacitor/core';

// Resolve the user's { lat, lng } once.
//
// On native iOS, WKWebView serves the app from the capacitor:// custom scheme,
// which Apple treats as an insecure origin — so the HTML5 navigator.geolocation
// prompt is blocked and the call fails silently. We therefore go through the
// native @capacitor/geolocation plugin (CoreLocation) on-device, and fall back
// to the web API in a normal browser / PWA. Rejects on denial/timeout; the
// caller decides what to do (we just skip the recenter).
export async function getUserLocation() {
  if (Capacitor.isNativePlatform()) {
    const { Geolocation } = await import('@capacitor/geolocation');
    let perm = await Geolocation.checkPermissions();
    if (perm.location !== 'granted' && perm.coarseLocation !== 'granted') {
      perm = await Geolocation.requestPermissions();
    }
    if (perm.location !== 'granted' && perm.coarseLocation !== 'granted') {
      throw new Error('Location permission not granted');
    }
    const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: false, timeout: 10000 });
    return { lat: pos.coords.latitude, lng: pos.coords.longitude };
  }

  // Web / PWA fallback.
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation unsupported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude }),
      reject,
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 60000 },
    );
  });
}
